import { useEffect } from 'react';

import type { PropsWithOptionalChildren } from '@/types';

interface ModelViewerProps extends PropsWithOptionalChildren {
  /**
   * The URL of the model to load.
   */
  src: string;
  /**
   * The alt text of the model.
   */
  alt: string;
  /**
   * The class name of the model.
   * @default ''
   */
  className?: string;
  /**
   * The URL of the poster image.
   */
  poster?: string;
  /**
   * The shadow intensity of the model.
   */
  'shadow-intensity'?: number;
  /**
   * Whether to enable camera controls.
   * @default false
   */
  'camera-controls'?: boolean;
  /**
   * The touch action of the model.
   */
  'touch-action'?: string;
  /**
   * The auto-rotate of the model.
   * @default false
   */
  'auto-rotate'?: boolean;
  /**
   * Disable zoom on the model.
   */
  'disable-zoom'?: boolean;
  /**
   * Disable tap on the model.
   */
  'disable-tap'?: boolean;
  /**
   * Scale of the model.
   */
  scale?: string;
}

const ModelViewer = ({ src, alt, className, ...props }: ModelViewerProps) => {
  useEffect(() => {
    import('@google/model-viewer');
  }, []);

  // @ts-expect-error model-viewer is a web component
  return <model-viewer src={src} alt={alt} class={className} {...props} />;
};

export default ModelViewer;
